// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.resume-container {
    width: 100%;
    margin: 0;
}

.resume-container .title {
    margin: 0 auto 10px;
}

.resume-container form {
    background-color: #0e0f15;
    color: white;
    width: 100%;
    border: 2px solid #f09502;
    padding: 40px !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.resume-container form > div {
    width: 100%;
}

.resume-container form label {
    margin-bottom: 3px;
    font-size: small;
    color: white !important;
}

.errorInput {
    background-color: rgb(255, 196, 196);
}

@media (max-width: 500px) {
    .resume-container .title {
        margin: 15px auto 6px;
    }

    .resume-container form {
        padding: 8px !important;
    }
}

.ml-10 {
    margin-left: 10px;
}

.form-check {
  padding: 10px 45px;
  border: 1px solid #b3b3b5;
}

.pt-20 {
  padding-top: 20px;
}

/* Estilos para botones */
/* Botón de Excel - Naranja claro */
.resume-container form .btn-primary {
  background-color: #ffb366 !important;
  border-color: #ffb366 !important;
  color: white !important;
}

.resume-container form .btn-primary:hover {
  background-color: #f09502 !important;
  border-color: #f09502 !important;
  color: white !important;
}

.resume-container form .btn-primary:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  opacity: 0.65;
}

/* Botones de acción - Naranja */
.resume-container form .btn-success {
  background-color: #f09502 !important;
  border-color: #f09502 !important;
  color: white !important;
}

.resume-container form .btn-success:hover {
  background-color: #d68202 !important;
  border-color: #d68202 !important;
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/balance-resume/balance-resume.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB,mCAAmC;AACnC;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB","sourcesContent":[":host {\n    width: 100%;\n}\n\n.resume-container {\n    width: 100%;\n    margin: 0;\n}\n\n.resume-container .title {\n    margin: 0 auto 10px;\n}\n\n.resume-container form {\n    background-color: #0e0f15;\n    color: white;\n    width: 100%;\n    border: 2px solid #f09502;\n    padding: 40px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.resume-container form > div {\n    width: 100%;\n}\n\n.resume-container form label {\n    margin-bottom: 3px;\n    font-size: small;\n    color: white !important;\n}\n\n.errorInput {\n    background-color: rgb(255, 196, 196);\n}\n\n@media (max-width: 500px) {\n    .resume-container .title {\n        margin: 15px auto 6px;\n    }\n\n    .resume-container form {\n        padding: 8px !important;\n    }\n}\n\n.ml-10 {\n    margin-left: 10px;\n}\n\n.form-check {\n  padding: 10px 45px;\n  border: 1px solid #b3b3b5;\n}\n\n.pt-20 {\n  padding-top: 20px;\n}\n\n/* Estilos para botones */\n/* Botón de Excel - Naranja claro */\n.resume-container form .btn-primary {\n  background-color: #ffb366 !important;\n  border-color: #ffb366 !important;\n  color: white !important;\n}\n\n.resume-container form .btn-primary:hover {\n  background-color: #f09502 !important;\n  border-color: #f09502 !important;\n  color: white !important;\n}\n\n.resume-container form .btn-primary:disabled {\n  background-color: #6c757d !important;\n  border-color: #6c757d !important;\n  opacity: 0.65;\n}\n\n/* Botones de acción - Naranja */\n.resume-container form .btn-success {\n  background-color: #f09502 !important;\n  border-color: #f09502 !important;\n  color: white !important;\n}\n\n.resume-container form .btn-success:hover {\n  background-color: #d68202 !important;\n  border-color: #d68202 !important;\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
